export default __webpack_public_path__ + "static/media/icon_new.3d9ae570.svg";